export default __webpack_public_path__ + "static/media/pbuilder-project.f007c712.webp";